<template>
  <div>
    <v-btn
      :text="!!text"
      :color="color"
      :class="{ 'font-weight-bold': isFontBold }"
      @click="onClick()"
    >
      <slot>{{ getText }}</slot>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NormalTextButton',
  props: {
    text: {
      type: String,
      default: ''
    },
    color: { default: 'primary' },
    isFontBold: { default: true }
  },
  data: () => {
    return {}
  },
  computed: {
    getText() {
      return this.$t(this.text)
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
